import React, { FC, useEffect } from 'react';
import clsx from 'clsx';
import { BookmarkModeEnum } from '../../../shared/constants';
import { useTheme } from '@material-ui/core';
import { FontAwesomeSpriteButton } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import {
  GetTeachersBookmarkByBook,
  useGetTeacherBookmarksByBookQuery,
} from 'src/modules/shared/slices/bookmark/api/bookmarkApi';
import { UrlParams } from 'src/modules/shared/types';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import {
  SidePanelModes,
  changePanelContent,
  openSidePanel,
} from 'src/modules/shared/slices/sidePanel/sidePanelSlice';
import {
  resetScroll,
  setBookmarkMode,
  setCurrentBookmarkBlockId,
} from 'src/modules/shared/slices/bookmark/entity/bookmarkEntity';
import { useParams } from 'react-router-dom';

import { handleScroll } from './helpers';

type TeacherBookmarkIndicatorProps = {
  blockId: string;
  className?: string;
};

export const TeacherBookmarkIndicator: FC<TeacherBookmarkIndicatorProps> = ({
  blockId,
  className,
}) => {
  // hooks
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const { bookId } = useParams<UrlParams>();
  //rtk
  const { data: bookmark } = useGetTeacherBookmarksByBookQuery(bookId as string);
  const bookmarkMode = useAppSelector((state) => state.bookmark.bookmarkMode);
  const scroll = useAppSelector((state) => state.bookmark.scroll);

  // react
  const isBookmarked =
    bookmark && bookmark.find((item: GetTeachersBookmarkByBook) => item.blockId === blockId);

  useEffect(() => {
    if (!scroll?.blockId) return;
    if (!scroll?.shouldScroll) return;
    handleScroll(scroll?.blockId);
    dispatch(resetScroll());
  }, [dispatch, scroll?.blockId, scroll?.shouldScroll]);

  const handleClick = (blockId: string) => {
    dispatch(setCurrentBookmarkBlockId(blockId));
    dispatch(setBookmarkMode(BookmarkModeEnum.TEACHER_OPTIONS));
    dispatch(changePanelContent(SidePanelModes.TEACHER_BOOKMARK));
    dispatch(openSidePanel(true));
  };

  return (
    <div id={`bookmark_${blockId}`} className={clsx(className, { active: isBookmarked })}>
      {(bookmarkMode !== BookmarkModeEnum.DISABLED || isBookmarked) && (
        <FontAwesomeSpriteButton
          id={`FontAwesomeSpriteButton-${blockId}`}
          icon={SpriteIconsLight.BOOKMARK}
          color={isBookmarked ? theme.palette.common.white : theme.palette.grey[400]}
          iconSize="md"
          onClick={() => handleClick(blockId)}
        />
      )}
    </div>
  );
};
